import { withField, withRow } from 'components/InputsUtils';
import { WrappedInputProps } from 'components/InputsUtils/types';
import RadioButtonGroup from './RadioButtonGroup';

export default withRow(withField<WrappedInputProps>(RadioButtonGroup));
